import React from 'react';

import { HStack, Text } from '@rtkwlf/fenrir-react';

import { Tooltip } from 'ae-components/tooltip/tooltip';

type TooltipForTextProps = {
  value: string;
};

export const TooltipForText: React.FC<TooltipForTextProps> = ({ value }) => {
  if (!value) return null;

  return (
    <HStack alignItems="center">
      <Tooltip
        tooltip={value}
        tooltipContentProps={{
          maxWidth: 'prose',
          side: 'top',
        }}
      >
        <Text
          display="inline-block"
          maxWidth={{
            laptop: '25rem',
            mobile: '8rem',
            tablet: '12rem',
            ultrawide: '80%',
          }}
          styledAs="body3"
          truncate
        >
          {value}
        </Text>
      </Tooltip>
    </HStack>
  );
};
